import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import api from '../lib/api';

const getVisitorId = () => {
  let vid = localStorage.getItem('wclc_vid');
  if (!vid) {
    vid = (window.crypto?.randomUUID && window.crypto.randomUUID()) || `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    localStorage.setItem('wclc_vid', vid);
  }
  return vid;
};

export const PageTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    if (path.startsWith('/admin')) return;
    let referrer = '';
    if (!sessionStorage.getItem('wclc_session')) {
      sessionStorage.setItem('wclc_session', '1');
      referrer = document.referrer || '';
    }
    api.post('/track', { path, visitor_id: getVisitorId(), referrer }).catch(() => {});
  }, [location.pathname]);

  return null;
};
